import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
const BrandHeroReceiveForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        receive: formData.receive,
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const receive = values.receive
        const heroId  = formData.id;
        onOk(heroId ,receive)
      }
    })
  }

  return (
    <Modal
      title={`Update Get Brand Product`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Get Brand Product">
        {getFieldDecorator(`receive`, {
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(
          <Radio.Group>
              <Radio value={true}>ใช่</Radio>
              <Radio value={false}>ไม่</Radio>
          </Radio.Group>
        )}
      </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <Button color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedBrandHeroReceiveForm = Form.create({ name: 'BrandHeroReceiveForm' })(
  BrandHeroReceiveForm
)
export default WrappedBrandHeroReceiveForm
